<input
  matInput
  [matDatepicker]="picker"
  [formControl]="dateControl"
  [placeholder]="placeholder"
  [min]="minDate"
  [max]="maxDate"
  (dateChange)="onDateChange($event.value)"
  (focusin)="onFocusIn()"
  (focusout)="onFocusOut($event)"
>
<mat-datepicker #picker>
  <mat-datepicker-actions>
    <div class="d-flex flex-column w-100">
    <mat-form-field>
      <mat-label>Time</mat-label>
      <input matInput
             [matTimepicker]="timePicker"
             [ngModel]="timeValue"
             (ngModelChange)="onTimeChange($event)">
      <mat-timepicker-toggle matSuffix [for]="timePicker"></mat-timepicker-toggle>
      <mat-timepicker #timePicker interval="15min"></mat-timepicker>
    </mat-form-field>
      <button mat-flat-button color="primary" class="w-100" matDatepickerApply>Confirm Date</button>
    </div>
  </mat-datepicker-actions>
</mat-datepicker>
